import axios from 'axios';
import { CONFIG } from '../../../../../environments';

const { endpoint } = window.HONDA_SHOP_ACCESSORIES;

export const fetchAccessoriesData = () => axios.get(CONFIG.ENDPOINT.concat(endpoint));